export default {
  employeeCol: {
    width: 300,
    display: 'flex',
  },
  actionCol: {
    width: 130,
    textAlign: 'right',
  },
  clearEmployee: {
    color: 'grey',
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
};



// WEBPACK FOOTER //
// ./src/components/Resources/ResourceDetailGrid/styles.js